import React from 'react';

import {
  formatISO9075,
  isDate,
  isEqual,
  addDays,
  startOfDay,
  endOfDay,
  startOfWeek,
  endOfWeek,
  addWeeks,
  startOfMonth,
  endOfMonth,
  addMonths,
  startOfToday,
  endOfToday,
  startOfTomorrow,
  startOfYesterday,
  set,
} from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';

const getDefaultRanges = (date, tz, timeMode) => {
  const defaultTime = {
    hours: timeMode == 'midday' ? 12 : 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0,
  };

  return [
    {
      label: 'Today',
      startDate: set(date, defaultTime),
      endDate: set(startOfTomorrow(), defaultTime),
      startDateValue: zonedTimeToUtc(set(startOfToday(), defaultTime), tz.data.tzCode),
      endDateValue: zonedTimeToUtc(set(startOfTomorrow(), defaultTime), tz.data.tzCode),
    },
    {
      label: 'Yesterday',
      startDate: set(startOfYesterday(), defaultTime),
      endDate: set(date, defaultTime),
      startDateValue: zonedTimeToUtc(set(startOfYesterday(), defaultTime), tz.data.tzCode),
      endDateValue: zonedTimeToUtc(set(startOfToday(), defaultTime), tz.data.tzCode),
    },
    {
      label: 'This Month',
      startDate: set(startOfMonth(date), defaultTime),
      endDate: set(startOfMonth(addMonths(date, 1)), defaultTime),
      startDateValue: zonedTimeToUtc(set(startOfMonth(date), defaultTime), tz.data.tzCode),
      endDateValue: zonedTimeToUtc(
        set(startOfMonth(addMonths(date, 1)), defaultTime),
        tz.data.tzCode,
      ),
    },
    {
      label: 'Last Month',
      startDate: set(startOfMonth(addMonths(date, -1)), defaultTime),
      endDate: set(startOfMonth(date), defaultTime),
      startDateValue: zonedTimeToUtc(
        set(startOfMonth(addMonths(date, -1)), defaultTime),
        tz.data.tzCode,
      ),
      endDateValue: zonedTimeToUtc(set(startOfMonth(date), defaultTime), tz.data.tzCode),
    },
  ];
};

export const defaultRanges = (tz, timeMode) => getDefaultRanges(new Date(), tz, timeMode);

export const formatDateTime = (date) => {
  const datejs = new Date(date);
  if (!isDate(datejs)) return '';
  return formatISO9075(datejs);
};

export const formatDate = (date) => {
  // console.log('formatDate: ', date);
  const datejs = new Date(date);
  if (!isDate(datejs)) return '';
  return formatISO9075(datejs, { representation: 'date' });
};

export const genParamsQueryFromDateRange = (dateRange) => {
  // console.log('genParamsQueryFromDateRange: ', dateRange);
  var query = new URLSearchParams({
    startDate: dateRange.startDate,
    endDate: dateRange.endDate,
    startDateValue: dateRange.startDateValue,
    endDateValue: dateRange.endDateValue,
    // timezone: {
    //   data: {
    //     label: 'Asia/Singapore (GMT+08:00)',
    //     name: '(GMT+08:00) Singapore, Woodlands',
    //     tzCode: 'Asia/Singapore',
    //     utc: '+08:00',
    //   },
    //   name: '(GMT+08:00) Singapore, Woodlands',
    // },
  });
  return query.toString();
};

export const useDateRange = (paramsString) => {
  // console.log('paramsString: ', paramsString);
  const [dateRange, setDateRange] = React.useState({
    startDate: paramsString?.startDate
      ? zonedTimeToUtc(new Date(paramsString.startDate), 'Asia/Singapore')
      : zonedTimeToUtc(startOfDay(new Date()), 'Asia/Singapore'),
    endDate: paramsString?.endDate
      ? zonedTimeToUtc(new Date(paramsString.endDate), 'Asia/Singapore')
      : zonedTimeToUtc(new Date(), 'Asia/Singapore'),
    startDateValue: paramsString?.startDateValue
      ? zonedTimeToUtc(new Date(paramsString.startDateValue), 'Asia/Singapore')
      : zonedTimeToUtc(startOfDay(new Date()), 'Asia/Singapore'),
    endDateValue: paramsString?.endDateValue
      ? zonedTimeToUtc(new Date(paramsString.endDateValue), 'Asia/Singapore')
      : zonedTimeToUtc(startOfToday(), 'Asia/Singapore'),
  });

  const onsetDateRange = (date) => {
    // date.endDateValue = startOfDay(addDays(date.endDate, 1));
    setDateRange(date);
  };

  return [dateRange, onsetDateRange];
};
